import { createContext } from "react";

const registrationContext = createContext();

export default registrationContext;
